import script from "./CompanionIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionIntro.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionIntro.vue?vue&type=style&index=0&id=16c67511&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c67511"]])

export default __exports__